import { Inject, Injectable } from '@angular/core';
import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  Environment,
  GetManyV2Dto,
  PageableListV2Dto,
  ProductDto,
  ResponseDto,
} from '@fleet-beat/core';
import { catchError, map, Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ProductsApiService {
  private readonly baseAdminUrl: string = `${this.environment.apiEndpoint}/admin`;
  private readonly baseUrl: string = `${this.environment.apiEndpoint}`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  getManyAsAdmin(params: GetManyV2Dto, auth: AuthHeaders): Observable<PageableListV2Dto<ProductDto>> {
    return this.baseApiService.get(`${this.baseAdminUrl}/products`, { auth, params }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<ProductDto[]>) => this.baseApiService.mapResponseV2(response)),
      map((response: ResponseDto<ProductDto[]>) => {
        return {
          data: response.data,
          ...response.meta,
        };
      }),
    );
  }

  getMany(params: GetManyV2Dto, auth: AuthHeaders): Observable<PageableListV2Dto<ProductDto>> {
    return this.baseApiService.get(`${this.baseUrl}/products`, { auth, params }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<ProductDto[]>) => this.baseApiService.mapResponseV2(response)),
      map((response: ResponseDto<ProductDto[]>) => {
        return {
          data: response.data,
          ...response.meta,
        };
      }),
    );
  }
}
